import store from "../store/index";

export default function waitForLoggedIn() {
	return new Promise(resolve => {
		if (store.getters["session/userIsLoggedIn"]) {
			return resolve();
		}
		const unwatch = store.watch(
			(_, getters) => getters["session/userIsLoggedIn"],
			isLoggedIn => {
				if (isLoggedIn) {
					resolve();
					unwatch();
				}
			}
		);
	});
}



// WEBPACK FOOTER //
// ./src/utils/wait-for-logged-in.js